import axios from 'axios';
import config from '../../config';

import tokenApi from './tokenApi';

const occupationInstance = axios.create({
	baseURL: config.api,
    headers: {
		'Content-Type': 'application/json'
	}
});

class OccupationApi {  

	static OccupationInsert(payload) {
		occupationInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();

		return occupationInstance.post('/occupation', payload)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static OccupationUpdate(payload, id) {
		occupationInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();

		return occupationInstance.patch(`/occupation/${id}`, payload)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static OccupationList() {
		occupationInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		
		return occupationInstance.get('/occupation?showAll=true')
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static OccupationDelete(id) {
		occupationInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		
		return occupationInstance.delete(`/occupation/${id}`)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

}

export default OccupationApi; 


